/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Account_Audit_Last_Sign_In_AtInputs */

const fr_account_audit_last_sign_in_at = /** @type {(inputs: Account_Audit_Last_Sign_In_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dernière connexion : ${i?.date}`)
};

/**

* @param {Account_Audit_Last_Sign_In_AtInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_last_sign_in_at = /** @type {((inputs: Account_Audit_Last_Sign_In_AtInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_Last_Sign_In_AtInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_last_sign_in_at(inputs)
});